import axios from "axios";
import ApiStore from "./ApiStore";
// var querystring = require('querystring');

export class ReportStore extends ApiStore {
  constructor() {
    super();
  }

  loadCustomerWorkList(name, completeFunc) {
    axios
      .get(
        "/report/work/all/?format=json&q=" +
          name +
          "&cat=owner_name&show_detail=true"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadCustomerStockRecordList(name, completeFunc) {
    axios
      .get(
        "/report/stockrecord/?format=json&q=" +
          name +
          "&cat=genpart&type=export"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadBillingCustomerList(year, month, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/billingcustomerlist/?format=json&year=" +
          year +
          "&month=" +
          month
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadBillingList(year, month, customerName, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/billinglist/?format=json&year=" +
          year +
          "&month=" +
          month +
          "&name=" +
          customerName
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportWorkJob(completeFunc) {
    let year = year - 543;
    let month = "";
    let start = 0,
      length = 10;
    axios
      .get(
        "/report/work/all?format=json&year=" +
          year +
          "&month=" +
          month +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportWorkStage(stage, completeFunc) {
    axios
      .get("/report/work/" + stage + "?format=json&withfield=true")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportWorkJobControl(completeFunc) {
    axios
      .get("/report/jobcontrolboard?format=json")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportControlBoard(control, completeFunc) {
    axios
      .get("/report/controlboard/" + control + "?format=json")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportWorkOfficeControl(completeFunc) {
    axios
      .get("/report/officecontrolboard?format=json")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportRecheckControl(completeFunc) {
    axios
      .get("/report/recheckcontrolboard?format=json")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportWorkJobControlByQuery(cat, query, completeFunc) {
    axios
      .get("/report/jobcontrolboard?cat=" + cat + "&q=" + query)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportJobControlByQuery(control, cat, query, status, completeFunc) {
    axios
      .get(
        "/report/controlboard/" +
          control +
          "?cat=" +
          cat +
          "&q=" +
          query +
          "&status=" +
          status
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportWorkJobControlByWork(workNo, completeFunc) {
    axios
      .get("/report/jobcontrolboard?format=json&wo=" + workNo)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportWork(
    apiCall,
    year,
    month,
    showDetail,
    start,
    length,
    q,
    cat,
    filter,
    completeFunc
  ) {
    let param = "";
    filter = Object.assign(
      { showUnprocessFinance: false, hasAdvanceDate: false },
      filter
    );

    if (apiCall === "wait_for_payment")
      param = "&show_unprocess_finance=" + filter.showUnprocessFinance;
    if (apiCall === "nopark")
      param = "&has_advance_date=" + filter.hasAdvanceDate;

    year = year - 543;
    const n = apiCall.search("\\?");
    if (n >= 0) {
      apiCall += "&format=json";
    } else {
      apiCall += "?format=json";
    }

    axios
      .get(
        "/report/work/" +
          apiCall +
          "&year=" +
          year +
          "&month=" +
          month +
          "&show_detail=" +
          showDetail +
          "&start=" +
          start +
          "&length=" +
          length +
          "&q=" +
          q +
          "&cat=" +
          cat +
          param
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAssetWork(
    apiCall,
    year,
    month,
    showDetail,
    start,
    length,
    q,
    cat,
    completeFunc
  ) {
    //console.log('loadSlipInfo',slipId)
    year = year - 543;
    axios
      .get(
        "/report/asset_work/" +
          apiCall +
          "?format=json&year=" +
          year +
          "&month=" +
          month +
          "&show_detail=" +
          showDetail +
          "&start=" +
          start +
          "&length=" +
          length +
          "&q=" +
          q +
          "&cat=" +
          cat
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportWorkQuery(apiCall, query, cat, showDetail, completeFunc) {
    axios
      .get(
        "/report/work/" +
          apiCall +
          "?format=json&q=" +
          query +
          "&cat=" +
          cat +
          "&show_detail=" +
          showDetail
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportRefixedWorkQuery(query, cat, showDetail, completeFunc) {
    axios
      .get(
        "/report/work/refixed_all?format=json&q=" +
          query +
          "&cat=" +
          cat +
          "&show_detail=" +
          showDetail
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportReceptionWorkQuery(apiCall, query, cat, showDetail, completeFunc) {
    axios
      .get(
        "/report/work/" +
          apiCall +
          "?format=json&q=" +
          query +
          "&cat=" +
          cat +
          "&show_detail=" +
          showDetail
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadStockList(
    type,
    query,
    cat,
    start,
    length,
    filter,
    completeFunc,
    errorFunc
  ) {
    let url =
      "/report/stock/" +
      type +
      "?q=" +
      query +
      "&cat=" +
      cat +
      "&start=" +
      start +
      "&length=" +
      length +
      "&filter=" +
      filter;
    console.log("loadStockList", url);
    axios
      .get(url)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadAdvancedStockList(
    type,
    query,
    cat,
    start,
    length,
    filter,
    advanced_search,
    completeFunc,
    errorFunc
  ) {
    let url =
      "/report/stock/" +
      type +
      "?q=" +
      query +
      "&cat=" +
      cat +
      "&start=" +
      start +
      "&length=" +
      length +
      "&filter=" +
      filter +
      "&advanced_search=" +
      advanced_search;
    console.log("loadStockList", url);
    axios
      .get(url)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error);
      });
  }

  loadStockHasSubCatList(
    type,
    query,
    cat,
    subcat,
    start,
    length,
    completeFunc
  ) {
    //console.log('loadSlipInfo',slipId)
    axios
      .get(
        "/report/stock/" +
          type +
          "?q=" +
          query +
          "&cat=" +
          cat +
          "&subcat=" +
          subcat +
          "&start=" +
          start +
          "&length=" +
          length +
          ""
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadStockTyreList(type, query, cat, subcat, start, length, completeFunc) {
    //console.log('loadSlipInfo',slipId)
    axios
      .get(
        "/report/stock/" +
          type +
          "?q=" +
          query +
          "&cat=" +
          cat +
          "&subcat=" +
          subcat +
          "&start=" +
          start +
          "&length=" +
          length +
          ""
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadOutOfStockList(type, start, length, completeFunc) {
    //console.log('loadSlipInfo',slipId)
    axios
      .get(
        "/report/outofstock/" +
          type +
          "?start=" +
          start +
          "&length=" +
          length +
          ""
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPurchaseOrderList(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    is_match,
    completeFunc
  ) {
    if (year !== "") year = year - 543;
    axios
      .get(
        "/report/purchaseorder/all?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length +
          "&is_match=" +
          is_match
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPurchaseOrderListRange(
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/purchaseorder/all?format=json&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPurchaseOrderApprovedRequestList(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    is_match,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/purchaseorder/approvedrequest?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length +
          "&is_match=" +
          is_match
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPurchaseOrderApprovedRequestListRange(
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/purchaseorder/approvedrequest?format=json&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPettycashList(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/pettycash/all?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUnPurchaseWork(query, cat, completeFunc) {
    axios
      .get("/report/unpurchasedwork?q=" + query + "&cat=" + cat)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadQuotationList(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/quotation/all?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadQuotationListRange(
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/quotation/all?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadInvoiceList(
    listView,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/invoice/" +
          listView +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadInvoiceListRange(
    listView,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/invoice/" +
          listView +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReceiptList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/receipt/" +
          viewMode +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReceiptListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/receipt/" +
          viewMode +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // loadTaxinvoiceList(year,month,day,searchBy,query,start,length,completeFunc){
  //   year = year - 543
  //   axios.get('/report/taxinvoice/all?format=json2&year='+year+'&month='+month+'&day='+day+'&q='+query+"&cat="+searchBy+'&start='+start+'&length='+length)
  //   .then(function(response){
  //     console.log(response)
  //     completeFunc(response.data)
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   })
  // }

  loadTaxinvoiceList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/taxinvoice/" +
          viewMode +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadTaxinvoiceListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/taxinvoice/" +
          viewMode +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadCreditNoteList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/creditnote/" +
          viewMode +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadCreditNoteListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/creditnote/" +
          viewMode +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadDebitNoteList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/debitnote/" +
          viewMode +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadDebitNoteListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/debitnote/" +
          viewMode +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadBillingNoteList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/billingnote/" +
          viewMode +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadBillingNoteListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/billingnote/" +
          viewMode +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReceiptVoucherList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/receiptvoucher/" +
          viewMode +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReceiptVoucherListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/receiptvoucher/" +
          viewMode +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPaymentVoucherList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/paymentvoucher/" +
          viewMode +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPaymentVoucherListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/paymentvoucher/" +
          viewMode +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUnpaidList(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/taxinvoice/unpaid?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPaidList(year, month, day, searchBy, query, start, length, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/taxinvoice/paid?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadCancelList(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/taxinvoice/cancel?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadCashbillList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/cashbill/" +
          viewMode +
          "?format=json2&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadCashbillListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/cashbill/" +
          viewMode +
          "?format=json2&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadIncomeList(year, month, searchBy, query, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/income?format=json&year=" +
          year +
          "&month=" +
          month +
          "&q=" +
          query +
          "&cat=" +
          searchBy
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadIncomeListRange(start, end, searchBy, query, completeFunc) {
    axios
      .get(
        "/report/income?format=json&start_date=" +
          start +
          "&end_date=" +
          end +
          "&q=" +
          query +
          "&cat=" +
          searchBy
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadBalanceList(year, month, searchBy, query, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/income?format=json&year=" +
          year +
          "&month=" +
          month +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&expense=true"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadBalanceListRange(start, end, searchBy, query, completeFunc) {
    axios
      .get(
        "/report/income?format=json&start_date=" +
          start +
          "&end_date=" +
          end +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&expense=true"
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadIncomeCategory(year, completeFunc) {
    year = year - 543;
    axios
      .get("/report/income_category?year=" + year)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPoAndExpense(year, month, day, start, length, completeFunc) {
    axios
      .get(
        "/report/poandexpense/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadMixPaintList(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/mixpaint/all?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadMixPaintListRange(
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/mixpaint/all?format=json&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUsageVolumeTransactionRecord(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/usage_volume_transaction_record/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUsageVolumeTransactionRecordRange(
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/usage_volume_transaction_record/?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadMixColorList(
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/mixedcolor/all?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadMixColorListRange(
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/mixedcolor/all?format=json&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadStat(year, month, viewForm, completeFunc) {
    axios
      .get(
        "/stat/all/?year=" +
          year +
          "&month=" +
          month +
          "&select_date=" +
          viewForm
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadInsureStat(type, year, month, day, viewForm, completeFunc) {
    year = year - 543;
    let select_date = "&select_date=" + viewForm;
    if (viewForm === "") select_date = "";

    axios
      .get(
        "/stat/" +
          (type === "insurer"
            ? "summary_insurer"
            : type === "emp"
            ? "summary_officer_quotation"
            : "summary_cash") +
          "?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          select_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadInsureStatRange(type, start_date, end_date, viewForm, completeFunc) {
    let select_date = "&select_date=" + viewForm;
    if (viewForm === "") select_date = "";

    axios
      .get(
        "/stat/" +
          (type == "insurer" ? "summary_insurer" : "summary_cash") +
          "?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          select_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportFixingOrder(year, month, day, q, cat, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/fixingorder/all?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&format=json&q=" +
          q +
          "&cat=" +
          cat
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAllYearIncomeOverview(year, completeFunc) {
    year = year - 543;
    axios
      .get("/report/allyearincome_overview?year=" + year)
      .then(function (response) {
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAllYearProfit(year, completeFunc) {
    year = year - 543;
    axios
      .get("/report/allyearprofit?year=" + year)
      .then(function (response) {
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPurchaseOrderByShop(year, month, credit, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/purchaseorder_shop?year=" +
          year +
          "&month=" +
          month +
          "&credit=" +
          credit
      )
      .then(function (response) {
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportBillingnoteReceivable(year, month, completeFunc) {
    year = year - 543;
    axios
      .get("/report/billingnote_receivable?year=" + year + "&month=" + month)
      .then(function (response) {
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadStockRequesterList(year, completeFunc) {
    year = year - 543;
    axios
      .get("/report/allyear_stock_requester_list?year=" + year)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadEmpStock(year, name, completeFunc) {
    year = year - 543;
    axios
      .get("/report/allyearemployee_stock?year=" + year + "&name=" + name)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAllYearEmpStockMonth(year, month, name, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/allyearemployee_stock_month?year=" +
          year +
          "&month=" +
          month +
          "&name=" +
          name
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportCommissionMechanic(year, month, day, empId, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/commission/mechanic?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&employee_id=" +
          empId
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportCommissionMechanicRange(start_date, end_date, empId, completeFunc) {
    axios
      .get(
        "/report/commission/mechanic?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&employee_id=" +
          empId
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadMechaniclist(year, month, completeFunc) {
    year = year - 543;
    axios
      .get("/report/commission_mechaniclist?year=" + year + "&month=" + month)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadMechanicDetail(
    year,
    month,
    employee_id,
    work_no,
    task_value,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/commission/mechanicdetail?year=" +
          year +
          "&month=" +
          month +
          "&employee_id=" +
          employee_id +
          "&work_no=" +
          work_no +
          "&task_value=" +
          task_value
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportProductTransactionRecord(
    year,
    month,
    day,
    groupId,
    recordType,
    productCat,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/product_transaction_record/" +
          groupId +
          "?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&record_type=" +
          recordType +
          "&cat_id=" +
          productCat
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportProductTransactionRecordRange(
    start_date,
    end_date,
    groupId,
    recordType,
    productCat,
    completeFunc
  ) {
    axios
      .get(
        "/report/product_transaction_record/" +
          groupId +
          "?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&record_type=" +
          recordType +
          "&cat_id=" +
          productCat
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportConsumablesProductTransactionRecord(
    year,
    month,
    day,
    groupId,
    recordType,
    catId,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/product_transaction_record/" +
          groupId +
          "?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&record_type=" +
          recordType +
          "&cat_id=" +
          catId
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportConsumablesProductTransactionRecordRange(
    start_date,
    end_date,
    groupId,
    recordType,
    catId,
    completeFunc
  ) {
    axios
      .get(
        "/report/product_transaction_record/" +
          groupId +
          "?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&record_type=" +
          recordType +
          "&cat_id=" +
          catId
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportProductBalance(year, month, day, groupId, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/product_balance/" +
          groupId +
          "?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportProductBalanceRange(start_date, end_date, groupId, completeFunc) {
    axios
      .get(
        "/report/product_balance/" +
          groupId +
          "?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPurchaseorderRecordProduct(
    year,
    month,
    day,
    shop_id,
    type,
    completeFunc
  ) {
    year = year - 543;
    let url =
      "/report/purchaseorder_record_product/" +
      type +
      "?year=" +
      year +
      "&month=" +
      month +
      "&day=" +
      day +
      "&shop_id=" +
      shop_id;
    if (type == "purchaseorder_item_product")
      url =
        "/report/" +
        type +
        "?year=" +
        year +
        "&month=" +
        month +
        "&day=" +
        day +
        "&shop_id=" +
        shop_id;
    axios
      .get(url)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPurchaseorderRecordProductRange(
    start_date,
    end_date,
    shop_id,
    type,
    completeFunc
  ) {
    let url =
      "/report/purchaseorder_record_product/" +
      type +
      "?start_date=" +
      start_date +
      "&end_date=" +
      end_date +
      "&shop_id=" +
      shop_id;
    if (type == "purchaseorder_item_product")
      url =
        "/report/" +
        type +
        "?start_date=" +
        start_date +
        "&end_date=" +
        end_date +
        "&shop_id=" +
        shop_id;
    axios
      .get(url)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPOStockItemByCar(year, month, day, cat, query, completeFunc) {
    year = year - 543;
    let url =
      "/report/po_stock_item_by_car?year=" +
      year +
      "&month=" +
      month +
      "&day=" +
      day +
      "&cat=" +
      cat +
      "&q=" +
      query;
    axios
      .get(url)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadSalesTaxCustomerList(year, month, day, customer_type, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/salestax_customerlist/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&customer_type=" +
          customer_type
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadSalesTaxCustomerListRange(
    start_date,
    end_date,
    customer_type,
    completeFunc
  ) {
    axios
      .get(
        "/report/salestax_customerlist/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&customer_type=" +
          customer_type
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportSalesTax(year, month, day, name, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/salestax/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&name=" +
          name
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportSalesTaxRange(start_date, end_date, name, completeFunc) {
    axios
      .get(
        "/report/salestax/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&name=" +
          name
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // loadReportAccountreceivableCustomerList(year,month,day,customer_type,completeFunc){
  //   year = year - 543
  //   axios.get('/report/accountreceivable_customerlist/?year='+year+'&month='+month+'&day='+day+'&customer_type='+customer_type)
  //   .then(function(response){
  //     console.log(response)
  //     completeFunc(response.data)
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   })
  // }

  // loadReportAccountreceivableCustomerListRange(start_date,end_date,customer_type,completeFunc) {
  //   axios.get('/report/accountreceivable_customerlist/?start_date='+start_date+'&end_date='+end_date+'&customer_type='+customer_type)
  //   .then(function (response) {
  //     console.log(response)
  //     completeFunc(response.data)
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   })
  // }

  loadReportAccountReceivable(year, month, day, cutomer_type, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/accountreceivable/" +
          cutomer_type +
          "?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAccountReceivableRange(
    start_date,
    end_date,
    cutomer_type,
    completeFunc
  ) {
    axios
      .get(
        "/report/accountreceivable/" +
          cutomer_type +
          "?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAccountReceivableDetail(
    year,
    month,
    day,
    cutomer_type,
    type,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/accountreceivable_detail/" +
          cutomer_type +
          "/" +
          type +
          "?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportFixingRefixed(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/fixingrefixed/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportFixingRefixedRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/fixingrefixed/?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportFixingPostponeAppointment(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/fixing_postponeappointment/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportFixingPostponeAppointmentRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/fixing_postponeappointment/?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadKpi(year, month, type, completeFunc) {
    year = year - 543;
    axios
      .get("/report/kpi/" + type + "?year=" + year + "&month=" + month)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadKpiRange(start_date, end_date, type, completeFunc) {
    axios
      .get(
        "/report/kpi/" +
          type +
          "?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadKpiDetail(year, month, empId, type, taskValue, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/kpi/" +
          type +
          "detail?year=" +
          year +
          "&month=" +
          month +
          "&employee_id=" +
          empId +
          "&task_value=" +
          taskValue
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUsageVolume(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/usage_volume/?year=" + year + "&month=" + month + "&day=" + day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUsageVolumeRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/usage_volume/?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUsageVolumeDetail(year, month, productcode, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/usage_volume_detail/?year=" +
          year +
          "&month=" +
          month +
          "&productcode=" +
          productcode
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUsageVolumeBalance(cat_id, completeFunc) {
    axios
      .get("/report/usage_volume_balance?cat_id=" + cat_id)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUncompletedWork(completeFunc) {
    axios
      .get("/report/uncompletedwork")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadUncompletedWorkDetail(payment_type, start_day, end_day, completeFunc) {
    axios
      .get(
        "/report/uncompletedwork_detail?payment_type=" +
          payment_type +
          "&start_day=" +
          start_day +
          "&end_day=" +
          end_day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportDeliveryWork(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/deliverywork?year=" + year + "&month=" + month + "&day=" + day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportDeliveryWorkRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/deliverywork?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportDeliveryWorkDetail(
    type,
    year,
    month,
    day,
    payment_type,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/deliverywork_detail/" +
          type +
          "?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&payment_type=" +
          payment_type
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportCurrentQuotationWork(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/currentquotationwork?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportCurrentQuotationWorkRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/currentquotationwork?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPendingfinanceWork(completeFunc) {
    axios
      .get("/report/pendingfinancework")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPendingfinanceWorkDetail(type, insurer_id, completeFunc) {
    axios
      .get(
        "/report/pendingfinancework_detail/" +
          type +
          "?insurer_id=" +
          insurer_id
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportJobCostSheetWork(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/jobcostsheetwork?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportJobCostSheetWorkRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/jobcostsheetwork?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportJobCostSheetWorkDetail(type, wo, completeFunc) {
    axios
      .get("/report/jobcostsheetwork_detail/" + type + "?wo=" + wo)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPendingApprovedquotationCustomerList(customer_type, completeFunc) {
    axios
      .get("/report/pendingapprovedquotation_customerlist/" + customer_type)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPendingApprovedQuotation(customer_type, q, completeFunc) {
    axios
      .get("/report/pendingapprovedquotation/" + customer_type + "?q=" + q)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPostPaymentCustomerList(year, month, day, customer_type, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/postpayment_customerlist/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&customer_type=" +
          customer_type
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPostPaymentCustomerListRange(
    start_date,
    end_date,
    customer_type,
    completeFunc
  ) {
    axios
      .get(
        "/report/postpayment_customerlist/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&customer_type=" +
          customer_type
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPostPayment(year, month, day, name, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/postpayment/all?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&name=" +
          name
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportPostPaymentRange(start_date, end_date, name, completeFunc) {
    axios
      .get(
        "/report/postpayment/all?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&name=" +
          name
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportKpiJobControl(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/kpi/jobcontrol?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportKpiJobControlRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/kpi/jobcontrol?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  saveColumnConfig(postData, completeFunc, errorFunc) {
    console.log("postData", postData);
    axios
      .post("/report/work_column_config", postData)
      .then(function (response) {
        console.log(response.data);
        let result = response.data;
        if (result.status === "OK") completeFunc(result);
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  loadCreditNoteDoc(docNo, completeFunc) {
    axios
      .get("/creditnote/doc?cn=" + docNo + "&format=json")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadInvoiceListByCustomer(q, status, completeFunc) {
    axios
      .get(
        "/report/invoice/all?format=json2&q=" +
          q +
          "&cat=customer_name&has_billingnote=" +
          status
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestSaleProduct(
    year,
    month,
    day,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_best_sale_product/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestJobcardProduct(
    year,
    month,
    day,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_best_jobcard_product/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestJobcardProductRange(
    start_date,
    end_date,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/analysis_best_jobcard_product/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestPurchaseProduct(
    year,
    month,
    day,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_best_purchase_product/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestPurchaseProductRange(
    start_date,
    end_date,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/analysis_best_purchase_product/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestJobcardService(
    year,
    month,
    day,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_best_jobcard_service/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestJobcardServiceRange(
    start_date,
    end_date,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/analysis_best_jobcard_service/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestJobcardBrand(
    year,
    month,
    day,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_best_jobcard_brand/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestJobcardBrandRange(
    start_date,
    end_date,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/analysis_best_jobcard_brand/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestPoShop(year, month, day, start, length, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_best_po_shop/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestPoShopRange(
    start_date,
    end_date,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/analysis_best_po_shop/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestJobcardInsurer(
    year,
    month,
    day,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_best_jobcard_insurer/?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportAnalysisBestJobcardInsurerRange(
    start_date,
    end_date,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/analysis_best_jobcard_insurer/?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockCard(year, month, day, start, length, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/stock_card/genpart?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockCardCost(
    year,
    month,
    day,
    start,
    length,
    cat_id,
    itemnum,
    completeFunc
  ) {
    axios
      .get(
        "/report/stock_card_cost/genpart?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&start=" +
          start +
          "&length=" +
          length +
          "&cat_id=" +
          cat_id +
          "&itemnum=" +
          itemnum
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockCardRange(start_date, end_date, start, length, completeFunc) {
    axios
      .get(
        "/report/stock_card/genpart?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockCardCostRange(
    start_date,
    end_date,
    start,
    length,
    cat_id,
    itemnum,
    completeFunc
  ) {
    axios
      .get(
        "/report/stock_card_cost/genpart?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&cat_id=" +
          cat_id +
          "&itemnum=" +
          itemnum
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockCardVolume(year, month, day, start, length, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/stock_card_volume/officemate?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockCardVolumeRange(
    start_date,
    end_date,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/stock_card_volume/officemate?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportSummaryDetail(
    type,
    job_type,
    id,
    year,
    month,
    day,
    viewForm,
    completeFunc
  ) {
    year = year - 543;
    let url =
      "/stat/summary_detail/" +
      (type === "emp" ? "officer_quotation" : type) +
      "/" +
      job_type +
      "/?q=" +
      id +
      "&year=" +
      year +
      "&month=" +
      month +
      "&day=" +
      day +
      "&select_date=" +
      viewForm;
    axios
      .get(url)
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockFixingCar(year, month, day, searchBy, query, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/stock_for_work/" +
          searchBy +
          "?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&query=" +
          query
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockFixingCarRange(
    start_date,
    end_date,
    searchBy,
    query,
    completeFunc
  ) {
    axios
      .get(
        "/report/stock_for_work/" +
          searchBy +
          "?start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&query=" +
          query
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadConfigCategoryReport(bf_role_id, completeFunc) {
    axios
      .get(
        "/report/config_category_report" +
          (bf_role_id === "" ? "" : "/" + bf_role_id)
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPermCategoryReport(completeFunc) {
    axios
      .get("/report/perm_category_report")
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  saveConfigCategoryReport(bf_role_id, postData, completeFunc, errorFunc) {
    console.log("postData", postData);
    axios
      .post(
        "/report/config_category_report" +
          (bf_role_id === "" ? "" : "/" + bf_role_id),
        postData
      )
      .then(function (response) {
        console.log(response.data);
        let result = response.data;
        if (result.status === "OK") completeFunc(result);
        else errorFunc(result);
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: "error", desc: error });
      });
  }

  loadReceptionList(
    viewMode,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/reception/" +
          viewMode +
          "?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReceptionListRange(
    viewMode,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/reception/" +
          viewMode +
          "?format=json&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadWithholdingTaxList(
    listView,
    year,
    month,
    day,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/withholdingtax/" +
          listView +
          "?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadWithholdingTaxListRange(
    listView,
    start_date,
    end_date,
    searchBy,
    query,
    start,
    length,
    completeFunc
  ) {
    axios
      .get(
        "/report/withholdingtax/" +
          listView +
          "?format=json&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&q=" +
          query +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPartPriceCompareList(
    year,
    month,
    day,
    searchBy,
    query,
    year_series,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/partpricecompare/all?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&year_series=" +
          year_series +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadPriceCompareList(
    year,
    month,
    day,
    searchBy,
    query,
    year_series,
    start,
    length,
    completeFunc
  ) {
    year = year - 543;
    axios
      .get(
        "/report/pricecompare/all?format=json&year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day +
          "&q=" +
          query +
          "&year_series=" +
          year_series +
          "&cat=" +
          searchBy +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAnalysisClaimOfTheMonth(year, month, start, length, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_claimofthemonth?year=" +
          year +
          "&month=" +
          month +
          "&start=" +
          start +
          "&length=" +
          length
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAnalysisInOutWork(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_inoutwork?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAnalysisInOutWorkRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/analysis_inoutwork?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAnalysisWorkCustomCost(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_work_customcost?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAnalysisWorkCustomCostRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/analysis_work_customcost?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAnalysisDeliveryEfficiency(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_delivery_efficiency?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadAnalysisDeliveryEfficiencyRange(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/analysis_delivery_efficiency?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadReportStockListInOut(start_date, end_date, completeFunc) {
    axios
      .get(
        "/report/sale_product_period?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  loadReportAnalysisWorkDebitCreditInOut(year, month, day, completeFunc) {
    year = year - 543;
    axios
      .get(
        "/report/analysis_work_debit_credit_and_inout?year=" +
          year +
          "&month=" +
          month +
          "&day=" +
          day
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  loadReportAnalysisWorkDebitCreditInOutRange(
    start_date,
    end_date,
    completeFunc
  ) {
    axios
      .get(
        "/report/analysis_work_debit_credit_and_inout?start_date=" +
          start_date +
          "&end_date=" +
          end_date
      )
      .then(function (response) {
        console.log(response);
        completeFunc(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

export default new ReportStore();



// WEBPACK FOOTER //
// ./src/stores/ReportStore.js